import { Badge } from '@/components/ui/badge'
import { buttonVariants } from '@/components/ui/button'
import { Card, CardContent, CardFooter, CardHeader } from '@/components/ui/card'
import { cn } from '@/lib/tailwind.utils'
import { ArrowRight } from 'lucide-react'
import type { TutorialItem } from '../types'

const tutorialBadgeStyles: Record<TutorialItem['type'], string> = {
  TUTORIAL: 'bg-yellow-200 text-yellow-800 hover:bg-yellow-200',
  DEMO: 'bg-emerald-200 text-emerald-800 hover:bg-emerald-200',
}

const TutorialCard = ({ tutorial }: { tutorial: TutorialItem }) => {
  const { type, date, title, description, href } = tutorial

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label={`${title} (opens in a new tab)`}
      className="group block h-full"
    >
      <Card className="flex h-full min-h-[204px] flex-col transition-colors hover:bg-neutral-50">
        <CardHeader className="pb-2">
          <div className="flex items-center justify-between">
            <Badge className={cn('text-xs font-semibold uppercase', tutorialBadgeStyles[type])}>
              {type}
            </Badge>
            <span className="text-xs text-muted-foreground">{date}</span>
          </div>

          <p className="min-h-10 line-clamp-2 text-sm font-semibold leading-5 text-foreground">
            {title}
          </p>
        </CardHeader>

        <CardContent className="flex-1 pb-2">
          <p className="line-clamp-2 text-xs leading-relaxed text-muted-foreground">
            {description}
          </p>
        </CardContent>

        <CardFooter className="mt-auto justify-end pt-0">
          <span
            className={cn(
              buttonVariants({ variant: 'ghost', size: 'sm' }),
              'pointer-events-none shrink-0',
            )}
          >
            View{' '}
            <ArrowRight size={16} className="transition-transform group-hover:translate-x-0.5" />
          </span>
        </CardFooter>
      </Card>
    </a>
  )
}

export default TutorialCard
